import { useMe } from "@/components/app/TrialBanner";
import { toast } from "sonner";

export const showOAuthResult = (r, qc) => {
  if (r.ok) toast.success(r.message); else toast.error(r.message);
  qc.invalidateQueries();
};

const BADGE = {
  CONNECTED: "border-[#00FF9D]/50 text-[#00FF9D]",
  "NEEDS RECONNECT": "border-[#FF5C7A]/60 text-[#FF8FA3] bg-[#FF5C7A]/10",
  "SYNC ISSUE": "border-[#FFB800]/50 text-[#FFD166]",
};

export const statusLabel = (connected, health) => {
  if (!connected) return "DEMO DATA";
  if (health?.status === "needs_reconnect") return "NEEDS RECONNECT";
  if (health?.status === "error") return "SYNC ISSUE";
  return "CONNECTED";
};

export const OwnerActions = ({ testid, children }) => {
  const me = useMe().data;
  const role = me?.role;
  if (!role) return null;
  if (me.demo) return <p data-testid={`${testid}-demo`} className="text-xs text-[#D9A6FF]">Connected in the demo. Syncs are simulated, so no real account is linked.</p>;
  if (role !== "owner") return <p data-testid={`${testid}-owner-only`} className="text-xs text-[#A3A3A3]">Only the workspace owner can connect or disconnect this account.</p>;
  return children;
};

export const IntegrationCard = ({ icon: Icon, color, name, desc, status, children, testid }) => (
  <div data-testid={testid} className={`rounded-xl border bg-[#121212] p-6 flex flex-col ${status === "NEEDS RECONNECT" ? "border-[#FF5C7A]/50" : "border-[#2A2A2A]"}`}>
    <div className="flex items-center justify-between">
      <span className="h-11 w-11 rounded-lg grid place-items-center bg-[#050505] border border-[#2A2A2A]"><Icon size={22} style={{ color }} /></span>
      <span data-testid={`${testid}-status`} className={`font-mono text-[10px] rounded-full px-2 py-1 border ${BADGE[status] || "border-[#2A2A2A] text-[#A3A3A3]"}`}>{status}</span>
    </div>
    <h3 className="font-display text-xl mt-5">{name}</h3>
    <p className="text-sm text-[#A3A3A3] mt-2 flex-1">{desc}</p>
    <div className="mt-6">{children}</div>
  </div>
);
